import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { errorMessage } from '../redux/errorState';
import { TYPE } from '../constant';
import { useUserInfo } from './';
import { translationKoMsg } from '../utils/utilityEtc';

export default function useAlert() {
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const dispath = useDispatch();

  const messageAlert = useCallback((message, func, code) => {
    let msg = message;
    if (code) {
      msg = t(`front_message.${code}`);
    }
    dispath(errorMessage('msg', msg, func));
  }, []);

  const codeMessage = useCallback((error, func) => {
    let msg = translationKoMsg(error?.code);
    if (info?.channelCode === TYPE.CHANNEL.GLOBAL01) {
      try {
        msg = t(`API_ERROR.${error.code}`) ? t(`API_ERROR.${error.code}`) : error.msg;
      } catch (error) {
        msg = error.msg;
      }
      
    }
    dispath(errorMessage(error.code, msg, func));
  })

  return [messageAlert, codeMessage]
}